"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Aug 07 2018
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * ConstraintSettingsConverter.
 *
 * @author RV
 */


var ConstraintSettingsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ConstraintSettingsConverter, _DataObjectConverter_);

  function ConstraintSettingsConverter() {
    _classCallCheck(this, ConstraintSettingsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ConstraintSettingsConverter).apply(this, arguments));
  }

  return ConstraintSettingsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ConstraintSettingsConverter = ConstraintSettingsConverter;